export const MANAGE_TABLE = "MANAGE_TABLE/MANAGE_TABLE";

export const MANAGE_TABLE_REQUEST = "MANAGE_TABLE/GET_REQUEST";
export const MANAGE_TABLE_FAILED = "MANAGE_TABLE/GET_FAILED";
export const MANAGE_TABLE_SUCCESS = "MANAGE_TABLE/GET_SUCCESS";

export const MANAGE_TABLE_DELETE_REQUEST = "MANAGE_TABLE/DELETE_REQUEST";
export const MANAGE_TABLE_DELETE_FAILED = "MANAGE_TABLE/DELETE_FAILED";
export const MANAGE_TABLE_DELETE_SUCCESS = "MANAGE_TABLE/DELETE_SUCCESS";

export const MANAGE_TABLE_UPDATE_REQUEST = "MANAGE_TABLE/UPDATE_REQUEST";
export const MANAGE_TABLE_UPDATE_FAILED = "MANAGE_TABLE/UPDATE_FAILED";
export const MANAGE_TABLE_UPDATE_SUCCESS = "MANAGE_TABLE/UPDATE_SUCCESS";

export const FILTER_SEARCH_REQUEST = "MANAGE_TABLE/FILTER_SEARCH_REQUEST";
export const FILTER_SEARCH_FAILED = "MANAGE_TABLE/FILTER_SEARCH_FAILED";
export const FILTER_SEARCH_SUCCESS = "MANAGE_TABLE/FILTER_SEARCH_SUCCESS";

export const FILTER_RESOLVE_REQUEST = "MANAGE_TABLE/FILTER_RESOLVE_REQUEST";
export const FILTER_RESOLVE_FAILED = "MANAGE_TABLE/FILTER_RESOLVE_FAILED";
export const FILTER_RESOLVE_SUCCESS = "MANAGE_TABLE/FILTER_RESOLVE_SUCCESS";

const types = {
    MANAGE_TABLE,

    FILTER_SEARCH_REQUEST,
    FILTER_SEARCH_FAILED,
    FILTER_SEARCH_SUCCESS,

    FILTER_RESOLVE_REQUEST,
    FILTER_RESOLVE_FAILED,
    FILTER_RESOLVE_SUCCESS,

    MANAGE_TABLE_REQUEST,
    MANAGE_TABLE_FAILED,
    MANAGE_TABLE_SUCCESS,

    MANAGE_TABLE_DELETE_REQUEST,
    MANAGE_TABLE_DELETE_FAILED,
    MANAGE_TABLE_DELETE_SUCCESS,

    MANAGE_TABLE_UPDATE_REQUEST,
    MANAGE_TABLE_UPDATE_FAILED,
    MANAGE_TABLE_UPDATE_SUCCESS,
};

export default types;
